export default __webpack_public_path__ + "static/media/Yoda.07de05a0.mp4";